/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2021 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import { useSelector } from "react-redux";
import { getBlocksSelector } from "utilities/BlockUtilities";
import { Block } from "types/Block";
import isEqual from "fast-deep-equal";

const useBlocks = (): Block[] => {
  return useSelector(getBlocksSelector, (lhs, rhs) => isEqual(lhs, rhs));
};

export default useBlocks;
